var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "about" }, [
      _c("div", { staticClass: "banner" }, [
        _c("div", { staticClass: "banner__title" }, [
          _vm._v("\n            易猎云（海南）科技有限公司\n        ")
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("国内领先的RPO企业招聘数字化解决方案提供商")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "introduction" }, [
        _c("div", { staticClass: "intr_box" }, [
          _c("p", { staticClass: "intr__title" }, [_vm._v("公司介绍")]),
          _vm._v(" "),
          _c("p", { staticClass: "intr__text" }, [
            _vm._v(
              "\n                易猎云，中国领先的RPO企业招聘管理系统综合解决方案供应商，以“招聘数字化”为使命，将先进的数字化管理理念融入招聘管理系统，做到招聘流程可视化、数字化、智能化，通过技术和服务赋能RPO招聘企业。\n            "
            )
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "intr__text",
              staticStyle: { "margin-top": ".3rem" }
            },
            [
              _vm._v(
                "\n                易猎云一直奉行“技术驱动，产品领先”的经营理念，从成立之初就聚集国内相关领域的顶尖人才，如智联、北森、BOSS直聘、BAT等知名企业，通过长期的技术投入和产品迭代，积累了完整成熟的产品矩阵，包括易猎招聘管理系统、易享员工服务系统、易猎职享等产品，产品之间实现了相互打通，全流程业务无缝衔接。迄今为止，累计服务客户包括位来小猎、陕西易通、熊猫云聘、点米科技、勇晖集团等500余家客户。\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "intr__text",
              staticStyle: { "margin-top": ".3rem" }
            },
            [
              _vm._v(
                "\n                 未来，易猎云将继续深耕RPO批量招聘及HRO领域，将先进的技术与在批量基础岗位招聘、小微人力资源企业数字化建设等方面积累的业务实践经验结合起来，打造国内RPO招聘领域的第一品牌，助力更多国内外人力资源企业实现数字化升级和改造。\n            "
              )
            ]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52f120b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52f120b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/about/index.vue
// module id = null
// module chunks = 